import React, { useState } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  Nav,
  NavItem,
  NavLink,
  CardBody,
} from "reactstrap"
import dashicon from "../../assets/icons/dashboardnewIcon.svg"
import dashdots from "../../assets/icons/dotsdashnew.svg"
import { DemoChart, SaleseChart } from "../DashboardCharts/dashcharts";

const Dashboardesign = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Dashboard${companyname ? ` | ${companyname}` : ''}`;
  const [activeTabe, setCActiveTabe] = useState();

  return (
    <React.Fragment>
      <div className="page-content tnt-scope px-2">
        <Card className="me-2 px-2 pb-2 main-dashboard-bg">
          <Container fluid>
            <Col lg="12" className="mt-4">
            <Row>
                <Col>
                  <Card className="styleofcard p-3">
                    <div className="d-flex flex-column gap-4">
                      <div className="d-flex justify-content-between">
                        <div><img src={dashicon} alt="dashicon" /></div>
                        <div><img src={dashdots} alt="dashicon" /></div>
                      </div>
                      <div>
                        <div className="text-of-dash mb-2">Total Project</div>
                        <h2 className="text-of-value">30</h2>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col>
                  <Card className="styleofcard1 p-3">
                    <div className="d-flex flex-column gap-4">
                      <div className="d-flex justify-content-between">
                      <div><img src={dashicon} alt="dashicon" /></div>
                      <div><img src={dashdots} alt="dashicon" /></div>
                      </div>
                      <div>
                        <div className="text-of-dash mb-2">Total Project</div>
                        <h2 className="text-of-value">30</h2>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col>
                  <Card className="styleofcard11 p-3">
                    <div className="d-flex flex-column gap-4">
                      <div className="d-flex justify-content-between">
                      <div><img src={dashicon} alt="dashicon" /></div>
                      <div><img src={dashdots} alt="dashicon" /></div>
                      </div>
                      <div>
                        <div className="text-of-dash mb-2">Total Project</div>
                        <h2 className="text-of-value">30</h2>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col>
                  <Card className="styleofcard2 p-3">
                    <div className="d-flex flex-column gap-4">
                      <div className="d-flex justify-content-between">
                        <div>Income</div>
                        <div>Project Name</div>
                      </div>
                      <div className="d-flex justify-content-center">
                        <div className="">
                          <Nav tabs>
                                <NavItem className="nav-tab-dash">
                                  <NavLink href="#" className="py-2 px-2 nav-link-dash" onClick={() => setCActiveTabe("1")}>Income (AED)</NavLink>
                                </NavItem>
                                <NavItem className="nav-tab-dash">
                                  <NavLink href="#" className="py-2 px-2 nav-link-dash" onClick={() => setCActiveTabe("2")}>Expense (AED)</NavLink>
                                </NavItem>
                          </Nav>
                        </div>
                      </div>
                    </div>
                    {activeTabe == "1" ? (
                    <SaleseChart />
                    ) : (
                      <DemoChart />
                    )}
                    
                  </Card>
                </Col>
                <Col lg="9">
                  <Row>
                    <Card>
                      <CardBody></CardBody>
                    </Card>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Container>
        </Card>
      </div>
    </React.Fragment>
  )
}

export default Dashboardesign
